export const LOCAL_STORAGE = {
	THANK_YOU_PAGE: "THANK_YOU_PAGE",
	IS_ALERT_SEEN: "IS_ALERT_SEEN",
	THEME: "THEME",
	TIMEZONE: "TIMEZONE",
	CURRENCY: "CURRENCY",
	IS_TNC_ACCEPTED: "IS_TNC_ACCEPTED",
	ISFREEMIUM: "ISFREEMIUM",
	CUSTOMER_DETAILS: "CUSTOMER_DETAILS",
	SAVED_CARDS: "SAVED_CARDS",
	CUSTOMER_ID: "CUSTOMER_ID",
	CURRENCY_SYMBOL: "CURRENCY_SYMBOL",
	PAYMENT_GATEWAY: "PAYMENT_GATEWAY",
	USER_ID: "USER_ID",
	TEST_BUSINESSES: "TEST_BUSINESSES",
	FIXED_FEE: "fixedFee",
	SIMPAYX_FEE: "simpayXFee",
	"UTMID": "UTMID",
};
